function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TextField, Typography } from 'seagull';
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getServiceName } from "./service.utils";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { connectControllerToTextField } from "../../../../utils/react-hook-form.utils";
import { requiredValidation } from 'validators';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ServiceNameCell(_ref) {
  let {
    service,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const form = useForm({
    mode: 'all',
    defaultValues: {
      name: service.name
    }
  });
  const onClick = () => {
    onOpenModal({
      renderContent: _ref2 => {
        let {
          draft,
          setDraft
        } = _ref2;
        return {
          title: 'Service name',
          testid: "edit-service-name-modal-".concat(index),
          onSubmit: defaultBehavior => {
            form.handleSubmit(defaultBehavior)();
          },
          content: /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
            children: /*#__PURE__*/_jsx(Controller, {
              control: form.control,
              name: "name",
              rules: requiredValidation(true),
              render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
                label: "Service name",
                testid: "edit-service-name-".concat(index),
                value: getServiceName({
                  serviceId: service.id,
                  draft
                }),
                onChange: e => {
                  form.setValue('name', e.target.value);
                  setDraft(draft.setService(service.id, s => _objectSpread(_objectSpread({}, s), {}, {
                    name: e.target.value
                  })));
                }
              }))
            })
          }))
        };
      }
    });
  };
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-service-name-cell-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "service-name-".concat(index),
      ellipsis: true,
      children: service.name
    })
  });
}